import {
  clearOldInteractionsEntries,
  STORAGE_KEYS,
  universalTrackRoomClicked,
} from '@/services/interactions-tracker';

// track room clicks from outside of Tagvenue

function trackRoomClicked(roomId, key) {
  universalTrackRoomClicked(key, roomId);
}

export function clearOldNavigationInteractionsEntries() {
  Object.keys(STORAGE_KEYS.NAVIGATION).forEach((key) => {
    clearOldInteractionsEntries(STORAGE_KEYS.NAVIGATION[key]);
  });
}

export function tryMarkingRoomAsExternallyClicked(roomId) {
  if (window.location.hash.startsWith('#position=')) {
    trackRoomClicked(roomId, STORAGE_KEYS.NAVIGATION.MAIL_NAVIGATION_TRACKER_v1);
  }

  let referrer = null;
  if (document.referrer) {
    try {
      referrer = new URL(document.referrer);
    } catch (err) {
      console.error(err);
    }
  }

  if (!referrer || referrer.hostname !== window.location.hostname) {
    trackRoomClicked(roomId, STORAGE_KEYS.NAVIGATION.EXTERNAL_NAVIGATION_TRACKER_v1);
  }

  if (referrer && referrer.hostname.includes('google')) {
    trackRoomClicked(roomId, STORAGE_KEYS.NAVIGATION.GOOGLE_NAVIGATION_TRACKER_v1);
  }
}
